module.exports = __webpack_public_path__ + "static/lisa-0011f2c438b8b577c0a5fe80606713da.png";